/* PRELUDIO - personalizzazioni ottobre 2026 */
(function () {
  var path = location.pathname.replace(/\/$/, '');
  var cap = function (s) { s = String(s).replace(/\s+/g, ' ').trim().toLowerCase(); return s.charAt(0).toUpperCase() + s.slice(1); };
  var pul = function (u) { try { return new URL(u, location.origin).pathname.replace(/\/$/, ''); } catch (e) { return ''; } };
  function logo() {
    var i = document.querySelector('.header__logo img, header img'); if (!i) return;
    var src = i.currentSrc || i.src;
    var ld = document.createElement('div'); ld.className = 'pl-loader'; ld.innerHTML = '<img alt="PRELUDIO" src="' + src + '">';
    document.body.appendChild(ld);
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank') return;
      var u; try { u = new URL(a.href, location.href); } catch (x) { return; }
      if (u.origin !== location.origin || a.getAttribute('href').charAt(0) === '#' || (u.pathname === location.pathname && u.hash)) return;
      ld.classList.add('on');
    });
    window.addEventListener('pageshow', function () { ld.classList.remove('on'); });
  }
  function cerca(nodi, catena) {
    for (var i = 0; i < nodi.length; i++) {
      var c = catena.concat([nodi[i]]);
      if (pul(nodi[i].u) === path) return c;
      var r = cerca(nodi[i].c || [], c);
      if (r) return r;
    }
    return null;
  }
  var EXTRA = {
    '/collections/giacche-aw26': ['Giacche', [['Donna', '/collections/nuovi-donna-giacche'], ['Uomo', '/collections/nuovi-uomo-giacche']]],
    '/collections/giubbini-aw26': ['Giubbini', [['Donna', '/collections/nuovi-donna-giubbini'], ['Uomo', '/collections/nuovi-uomo-giubbini']]],
    '/collections/maglieria-aw26': ['Maglieria', [['Donna', '/collections/nuovi-donna-maglioni'], ['Uomo', '/collections/nuovi-uomo-maglioni']]],
    '/collections/calzature-aw26': ['Calzature', [['Donna', '/collections/donna-calzature-collezione'], ['Uomo', '/collections/uomo-calzature-collezione']]]
  };
  function intestazioneCollezione() {
    if (path.indexOf('/collections/') === -1 || path.indexOf('/products/') !== -1) return;
    var toolbar = document.querySelector('.collection-toolbar');
    if (!toolbar || document.querySelector('.preludio-colhead')) return;
    var titoloEl = document.querySelector('.collection-toolbar__title');
    var titolo = cap(titoloEl ? titoloEl.textContent : document.title.split(/\s[–|-]\s/)[0]);
    var catena = [], figli = [];
    var trovato = window.PL_MENU ? cerca(window.PL_MENU, []) : null;
    if (trovato) {
      var ultimo = trovato[trovato.length - 1];
      titolo = cap(ultimo.t);
      catena = trovato.slice(0, -1).map(function (n) { return { t: n.t, h: n.u }; });
      figli = (ultimo.c || []).map(function (n) { return { t: n.t, h: n.u }; });
    } else if (EXTRA[path]) {
      catena = [{ t: 'Nuovi arrivi', h: '/collections/collezione-fw26-226' }];
      titolo = EXTRA[path][0];
      figli = EXTRA[path][1].map(function (x) { return { t: x[0], h: x[1] }; });
    } else if (path.indexOf('/collections/designers-') === 0) {
      catena.push({ t: 'Designers', h: '/pages/brand-list' });
    }
    var vend = new URLSearchParams(location.search).get('filter.p.vendor');
    if (vend) { catena.push({ t: titolo, h: path }); titolo = vend; }
    var arch = path.indexOf('/collections/archivio') === 0;
    var html = '<h1 class="preludio-titolo">';
    catena.forEach(function (c) { html += (c.h ? '<a href="' + c.h + '">' + cap(c.t) + '</a>' : '<span>' + cap(c.t) + '</span>') + '<span class="sep">/</span>'; });
    html += '<span class="corrente">' + titolo + '</span></h1>';
    var cnt = document.querySelector('.collection-toolbar__products-count');
    if (cnt) html += '<p class="preludio-conteggio">' + cnt.textContent.trim() + '</p>';
    if (figli.length > 1) html += '<nav class="preludio-chips">' + figli.map(function (f) { return '<a href="' + f.h + '">' + cap(f.t) + '</a>'; }).join('') + '</nav>';
    if (arch) {
      var voci = [['Tutto', '/collections/archivio'], ['Donna', '/collections/archivio-donna'], ['Uomo', '/collections/archivio-uomo'], ['Bambina', '/collections/archivio-bambina'], ['Bambino', '/collections/archivio-bambino'], ['Neonati', '/collections/archivio-neonati']];
      html += '<nav class="preludio-switch">' + voci.map(function (v) { return '<a href="' + v[1] + '"' + (v[1] === path ? ' class="attivo"' : '') + '>' + v[0] + '</a>'; }).join('') + '</nav>';
    }
    var box = document.createElement('div');
    box.className = 'preludio-colhead' + (arch ? ' preludio-colhead--archivio' : '');
    box.innerHTML = html;
    var sezione = toolbar.closest('.shopify-section') || toolbar.parentElement;
    sezione.parentElement.insertBefore(box, sezione);
  }
  function schedaProdotto() {
    if (path.indexOf('/products/') === -1) return;
    var form = document.querySelector('form[action*="/cart/add"]');
    var picker = document.querySelector('variant-picker');
    if (form && picker && !picker.dataset.preludio) {
      picker.dataset.preludio = '1';
      var scelta = picker.querySelectorAll('input[type="radio"], option').length <= 1;
      /* v19: la scritta "Seleziona la taglia" prima della scelta la scrive il blocco servizi della scheda; dopo la scelta (o con ?variant= nell'indirizzo) il riquadro mostra la taglia */
      var segna = function () { scelta = true; document.body.classList.add('pl-taglia-scelta'); };
      if (scelta || /[?&]variant=/.test(location.search)) segna();
      /* il riquadro mostra sempre la taglia del radio scelto; corretto subito (prima che lo schermo si ridisegni) a ogni rimontaggio del tema */
      var mostra = function () {
        if (!scelta) return;
        document.querySelectorAll('main variant-picker').forEach(function (p) {
          p.querySelectorAll('button.select').forEach(function (b) {
            var id = b.getAttribute('aria-controls'), pop = id && document.getElementById(id); if (!pop) return;
            var r = pop.querySelector('input[type="radio"]:checked'); if (!r) return;
            var l = r.closest('.popover__value-option'), v = l && l.querySelector('span');
            var tx = (v ? v.textContent : '').trim(); if (!tx) return;
            var sp = b.querySelector('span[id$="-selected-value"]');
            if (sp) { if (sp.textContent.trim() !== tx) sp.textContent = tx; }
            else if (b.textContent.trim() !== tx) b.textContent = tx;
          });
        });
      };
      var radice = picker.closest('.shopify-section') || document.querySelector('main') || document.body;
      new MutationObserver(mostra).observe(radice, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['checked'] });
      mostra();
      var sblocca = function () { segna(); var av = document.querySelector('.preludio-avviso-taglia'); if (av) av.remove(); mostra(); setTimeout(mostra, 0); setTimeout(mostra, 400); };
      /* rigo sotto il dito: diventa grigio mentre si tocca o si scorre la lista (su iPhone :hover e :active non bastano) */
      var SEL = 'x-popover[id^="popover-variant-dropdown"] .popover__value-option';
      var accendi = function (el) { document.querySelectorAll('.pl-dito').forEach(function (x) { if (x !== el) x.classList.remove('pl-dito'); }); if (el) el.classList.add('pl-dito'); };
      var sotto = function (t) { var e = t && document.elementFromPoint(t.clientX, t.clientY); return e && e.closest(SEL); };
      document.addEventListener('touchstart', function (e) { var r = e.target.closest && e.target.closest(SEL); if (r) accendi(r); }, { passive: true });
      document.addEventListener('touchmove', function (e) { if (!document.querySelector('.pl-dito')) return; accendi(sotto(e.touches[0])); }, { passive: true });
      var spegni = function () { setTimeout(function () { accendi(null); }, 350); };
      document.addEventListener('touchend', spegni, { passive: true });
      document.addEventListener('touchcancel', spegni, { passive: true });
      /* v20: la prima taglia e' gia' spuntata dal tema, toccandola la tendina restava aperta e sembrava non selezionata: ora la conferma e chiude */
      document.addEventListener('click', function (e) {
        var l = e.target.closest && e.target.closest(SEL); if (!l || e.target.closest('.pbis-link')) return;
        var r = l.querySelector('input[type="radio"]'); if (!r || !r.checked) return;
        sblocca(); var pop = l.closest('x-popover');
        setTimeout(function () { if (pop && pop.hide && pop.hasAttribute('open')) pop.hide(); accendi(null); }, 120);
      }, true);
      picker.addEventListener('change', sblocca);
      picker.addEventListener('click', function (e) { if (e.target.closest('[role="option"], label, li')) sblocca(); });
      document.addEventListener('variant:change', sblocca);
      form.addEventListener('submit', function (e) {
        if (scelta) return;
        e.preventDefault(); e.stopImmediatePropagation();
        if (!document.querySelector('.preludio-avviso-taglia')) { var p = document.createElement('p'); p.className = 'preludio-avviso-taglia'; p.textContent = 'Seleziona la taglia per continuare.'; picker.appendChild(p); }
      }, true);
      if (!picker.querySelector('a.preludio-guida')) { var g = document.createElement('a'); g.className = 'preludio-guida'; g.href = '/pages/guida-taglie'; g.target = '_blank'; g.textContent = 'Guida taglie'; picker.appendChild(g); }
    }
    var lista = document.querySelector('.preludio-servizi');
    if (lista && !lista.dataset.pl) {
      lista.dataset.pl = '1';
      var TAGLIO = 13, d = new Date();
      var lav = function (x) { var w = x.getDay(); return w !== 0 && w !== 6; };
      var avanti = function (x, n) { var y = new Date(x); while (n > 0) { y.setDate(y.getDate() + 1); if (lav(y)) n--; } return y; };
      var oggi = lav(d) && d.getHours() < TAGLIO;
      var part = oggi ? d : avanti(d, 1);
      var fmt = function (x) { return x.toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long' }); };
      var righe = ['<li><strong>Consegna</strong> ' + (oggi ? 'ordina entro le ' + TAGLIO + ':00, ' : '') + 'arriva tra ' + fmt(avanti(part, 1)) + ' e ' + fmt(avanti(part, 2)) + '</li>'];
      var sped = document.querySelector('.preludio-aw26-shipping');
      if (sped) righe.push('<li><strong>Spedizione gratuita</strong> su questo articolo' + (sped.querySelector('[data-copy-code]') ? ', con il codice AW26FREE <button type="button" class="pl-codice">Copia</button>' : '') + '</li>');
      righe.push('<li><strong>Reso</strong> entro 14 giorni</li>');
      righe.push('<li><strong>Ritiro in boutique</strong> a Napoli</li>');
      righe.push('<li><strong>4,9/5</strong> su Trustpilot</li>');
      lista.innerHTML = righe.join('');
      var bc = lista.querySelector('.pl-codice');
      if (bc) bc.addEventListener('click', function () { try { navigator.clipboard.writeText('AW26FREE'); bc.textContent = 'Copiato'; } catch (x) {} });
    }
  }
  function etichettePrezzo() {
    document.querySelectorAll('.sr-only, .visually-hidden').forEach(function (s) {
      if (s.textContent.trim() !== 'Prezzo scontato') return;
      var l = s.closest('price-list, .price-list') || s.parentElement.parentElement;
      if (l && !l.querySelector('compare-at-price, .compare-at-price, s, del')) s.textContent = 'Prezzo';
    });
  }
  var G = { 'Cappotto': 'cappotti', 'Giacca': 'giacche', 'Giubbino': 'giubbini', 'Parka': 'parka', 'Gilet': 'gilet', 'Pelliccia': 'pellicce', 'Maglia': 'maglie', 'Maglione': 'maglioni', 'Cardigan': 'cardigan', 'Felpa': 'felpe', 'Camicia': 'camicie', 'Blusa': 'bluse', 'Top': 'top', 'T-shirt': 't-shirt', 'Abito': 'abiti', 'Gonna': 'gonne', 'Pantalone': 'pantaloni', 'Jeans': 'jeans', 'Stivale': 'stivali', 'Stivaletto': 'stivaletti', 'Sneakers': 'sneakers', 'Scarpe': 'scarpe', 'Mocassino': 'mocassini', 'Decollete': 'decollete', 'Ballerina': 'ballerine', 'Borsa': 'borse', 'Pochette': 'pochette', 'Zaino': 'zaini', 'Portafoglio': 'portafogli', 'Cintura': 'cinture', 'Sciarpa': 'sciarpe', 'Cappello': 'cappelli', 'Guanti': 'guanti', 'Polo': 'polo', 'Leggings': 'leggings', 'Bermuda': 'bermuda', 'Tailleur': 'tailleur' };
  function correlati() {
    if (path.indexOf('/products/') === -1) return;
    var handle = path.split('/products/')[1];
    (window.PL_PRODOTTO ? Promise.resolve(window.PL_PRODOTTO) : fetch('/products/' + handle + '.js').then(function (r) { return r.json(); })).then(function (p) {
      var tags = (p.tags || []).join(',');
      var sett = ['Donna', 'Uomo', 'Bambina', 'Bambino'].find(function (s) { return tags.indexOf('SETTORE_' + s) !== -1; });
      if (!sett) return;
      var s = sett.toLowerCase(), g = G[p.type];
      var coll = g ? (s === 'donna' && g === 'abiti' ? 'abiti-donna' : s + '-' + g) : s + '-collezione';
      var prova = function (h) { return fetch('/collections/' + h).then(function (r) { if (!r.ok) throw 0; return r.text(); }); };
      return prova(coll).catch(function () { return prova(s + '-collezione'); }).then(function (txt) {
        var doc = new DOMParser().parseFromString(txt, 'text/html');
        var carte = Array.prototype.slice.call(doc.querySelectorAll('product-card')).filter(function (c) { var a = c.querySelector('a[href*="/products/"]'); return a && a.getAttribute('href').indexOf(handle) === -1; }).slice(0, 8);
        if (carte.length < 2) return;
        var dest = document.querySelector('product-recommendations'); if (!dest) return;
        var box = document.createElement('div'); box.className = 'preludio-correlati';
        box.innerHTML = '<p class="preludio-correlati__titolo">Potrebbe interessarti anche</p><div class="preludio-correlati__griglia"></div>';
        var gr = box.querySelector('.preludio-correlati__griglia');
        carte.forEach(function (c) { gr.appendChild(document.importNode(c, true)); });
        var sec = dest.closest('.shopify-section') || dest; sec.innerHTML = ''; sec.appendChild(box);
        etichettePrezzo();
      });
    }).catch(function () {});
  }
  function avvia() { logo(); intestazioneCollezione(); schedaProdotto(); etichettePrezzo(); correlati(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia); else avvia();
})();